import { cn } from '@/shared/lib/cn';

type DotsProps = {
  className?: string;
  /** 점 색 — 기본은 글자색(currentColor)을 따른다 */
  dotClassName?: string;
};

/** TDS loading — 같은 색 점 3개가 차례로 깜빡인다 (skeleton shimmer 대신) */
export function Dots({ className, dotClassName }: DotsProps) {
  return (
    <span aria-hidden className={cn('inline-flex items-center gap-1.5', className)}>
      {[0, 1, 2].map(index => (
        <span
          key={index}
          className={cn('size-2 animate-dot rounded-full bg-current', dotClassName)}
          style={{ animationDelay: `${index * 0.2}s` }}
        />
      ))}
    </span>
  );
}

type PageLoaderProps = {
  label?: string;
  className?: string;
};

/** 화면·영역 로딩 — 가운데 3-dot 과 스크린리더용 문구 */
export function PageLoader({ label = '불러오고 있어요', className }: PageLoaderProps) {
  return (
    <div
      role='status'
      className={cn('flex min-h-60 items-center justify-center text-fg-disabled', className)}
    >
      <Dots />
      <span className='sr-only'>{label}</span>
    </div>
  );
}
